const TOKEN_KEY = "sunfish.checkin.deviceToken";
const META_KEY = "sunfish.checkin.deviceMeta";

export interface DeviceMeta {
	deviceId: string;
	eventId: string;
	eventName: string;
	deviceName: string;
	mode: "operator" | "kiosk";
	qrPublicKey: string | null;
	brandColor: string | null;
	logoUrl: string;
}

export function getDeviceToken(): string | null {
	if (typeof window === "undefined") return null;
	return window.localStorage.getItem(TOKEN_KEY);
}

export function getDeviceMeta(): DeviceMeta | null {
	if (typeof window === "undefined") return null;
	const raw = window.localStorage.getItem(META_KEY);
	return raw ? (JSON.parse(raw) as DeviceMeta) : null;
}

// Store the token alone so the bearer client can call whoami to resolve the
// device's event/name before the full session is persisted.
export function setDeviceToken(token: string): void {
	window.localStorage.setItem(TOKEN_KEY, token);
}

export function saveDeviceSession(token: string, meta: DeviceMeta): void {
	window.localStorage.setItem(TOKEN_KEY, token);
	window.localStorage.setItem(META_KEY, JSON.stringify(meta));
}

export function clearDeviceSession(): void {
	window.localStorage.removeItem(TOKEN_KEY);
	window.localStorage.removeItem(META_KEY);
}
